var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSentinelOne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1594 10.4941H25.8465V32.2479H22.1594V10.4941ZM26.7398 37.4941L30.4241 35.2413V16.4078C29.3318 15.6086 28.0735 15.0584 26.7398 14.797V37.4941ZM17.5705 35.2526L21.2576 37.5054V14.8083C19.9238 15.0657 18.6645 15.612 17.5705 16.4078V35.2526ZM31.3173 11.5276V34.8471L33.0296 33.7995C33.6427 33.4015 34.1443 32.8575 34.4879 32.2176C34.8316 31.5778 35.0063 30.8628 34.9959 30.1387V19.1252C35.0044 15.9488 31.3173 11.5276 31.3173 11.5276ZM13.0044 30.1303C12.9932 30.8545 13.1675 31.5698 13.5113 32.2098C13.855 32.8497 14.357 33.3937 14.9707 33.7911L16.683 34.8386V11.5276C16.683 11.5276 13.0044 15.9488 13.0044 19.1252V30.1303Z",
    fill: "#6B0AEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentinelOne);
export default __webpack_public_path__ + "static/media/SentinelOne.e6f2fee388ceceba55d1b48afdf5462a.svg";
export { ForwardRef as ReactComponent };